import theme from '@styles/theme';
import { TMarginsTypes } from '@features/cms/typescript';
export default {
  container: (bg: string | undefined, mt: TMarginsTypes | undefined, mb: TMarginsTypes | undefined) => ({
    p: ['64px 16px 64px 16px', '64px 16px 64px 16px', '80px 0 80px 24px', '6.035379813vw 10.14564815vw 6.035379813vw 10.14564815vw'],
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'row'],
    justifyContent: 'space-between',
    bg: bg || theme.rawColors.beige500,
    overflowX: 'hidden',
    mt: mt || 0,
    mb: mb || 0
  }),
  leftPart: {
    width: ['100%', '100%', '100%', '39.177939646vw']
  },
  rightPart: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    width: ['100%', '100%', '100%', '31.165452653vw'],
    pl: [24, 24, 40, 0]
  },
  imgWithText: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    justifyItems: 'space-betwen',
    pt: ['64px', '64px', '84px', '0px'],
    height: '100%'
  },
  imgContainer: {
    width: '100%',
    paddingTop: '75%',
    position: 'relative',
    ml: [24, 24, 40, 0],
    minHeight: '252px',
    img: {
      objectFit: 'cover'
    },
    mt: [0, 0, 0, 40],
    mb: [16, 16, 16, 0]
  },
  tag: {
    fontFamily: theme.fonts.uniform,
    m: ['24px 0 24px 24px', '24px 0 24px 24px', '24px 0 24px 40px', '16px 0px 0']
  },
  content: {
    fontSize: [theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.text],
    lineHeight: ['140%', '140%', '140%', '140%', '175%'],
    m: ['0 0 24px', '0px 0 24px 0', '0px 0 24px', '24px 0px 24px']
  },
  rightImgContainer: {
    width: ['calc(100% - 16px)', 'calc(100% - 16px)', 'calc(100% - 40px)', '100%'],
    paddingTop: '100%',
    position: 'relative',
    mb: [24, 24, 24, 0],
    img: {
      objectFit: 'cover'
    }
  },
  button: {
    pt: ['initial', 'initial', 'initial', 'auto']
  },
  imageWithTextContent: {
    display: 'flex',
    flexDirection: ['column-reverse', 'column-reverse', 'column-reverse', 'column']
  },
  heading: {
    position: ['absolute', 'absolute', 'absolute', 'static'],
    zIndex: theme.zIndex.documentUp,
    top: ['0px', '0px', '0px', 'initial']
  }
};